import React from 'react';

//import Scss
import './assets/scss/themes.scss';

//import Route
import Route from './Routes/index.js';
import { ToastContainer } from 'react-toastify';

function App () {
  return (
    <React.Fragment>
      <Route />
      <ToastContainer/>
    </React.Fragment>
  );
}

export default App;
